<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
        <v-spacer></v-spacer>
      </section>

      <h3 class="mx-2">商品と客先を選択してください</h3>
      <v-row no-gutters>
        <v-col cols="6" class="pa-2">
          <v-combobox
            ref="products"
            label="商品"
            v-model="selectProduct"
            :items="productItems"
            append-icon="fas fa-list-ol"
            @click.stop="openSelected('products')"
            readonly outlined hide-details="auto">
          </v-combobox>
        </v-col>
        <v-col cols="6" class="pa-2">
          <v-combobox
            ref="customers"
            label="客先"
            v-model="selectCustomer"
            :items="customerItems"
            append-icon="fas fa-list-ol"
            @click.stop="openSelected('customers')"
            readonly outlined hide-details="auto">
          </v-combobox>
        </v-col>
      </v-row>

      <div v-if="!loading" class="pa-2">
        <h3 class="mt-5">商品概要</h3>
        <section class="product-outline">
          <div class="img">
            <div class="py-2">
              <v-img :src="productItem.mainPicUrl" width="120" height="120" @click="lightboxFunc(productItem.mainPicUrl)" />
            </div>
          </div>
          <div class="outline">
            <div class="py-2">
              <v-text-field
                label="名称"
                v-model="productItem.name"
                outlined disabled hide-details="auto">
              </v-text-field>
            </div>
            <div class="py-2">
              <v-text-field
                label="メインタイトル"
                v-model="productItem.mainTitle"
                outlined disabled hide-details="auto">
              </v-text-field>
            </div>
            <div class="py-2">
              <v-text-field
                label="サブタイトル"
                v-model="productItem.subTitle"
                outlined disabled hide-details="auto">
              </v-text-field>
            </div>
          </div>
        </section>
        <h3>品目</h3>
        <section>
          <v-form v-model="valid">
            <div class="py-2">
              <ul class="model-list">
                <li v-for="(item, index) in desserts" :key="index">
                  <div class="model-image">
                    <v-img :src="item.mainPic" width="120" height="120" @click="lightboxFunc(item.mainPic)" />
                  </div>
                  <ul class="model-row">
                    <li class="name">
                      <v-text-field
                        label="品名"
                        v-model="item.name"
                        :rules="[rules.required]"
                        class="required"
                        outlined hide-details="auto">
                      </v-text-field>
                    </li>
                    <li class="code">
                      <v-text-field
                        label="品番"
                        v-model="item.code"
                        outlined hide-details="auto">
                      </v-text-field>
                    </li>
                    <li class="size">
                      <v-text-field
                        label="サイズ"
                        v-model="item.size"
                        outlined disabled hide-details="auto">
                      </v-text-field>
                    </li>
                    <li class="color">
                      <v-text-field
                        label="色"
                        v-model="item.color"
                        outlined disabled hide-details="auto">
                      </v-text-field>
                    </li>
                    <li class="material">
                      <v-text-field
                        label="材質"
                        v-model="item.material"
                        outlined disabled hide-details="auto">
                      </v-text-field>
                    </li>
                    <li class="static-value">
                      <v-text-field
                        label="定価 ( 100% )"
                        type="number"
                        v-model="item.staticValue"
                        outlined hide-details="auto" disabled>
                      </v-text-field>
                    </li>
                    <li class="standard-value">
                      <v-text-field
                        :label="'標準価格 ( ' + selectCustomer.rate + '% )'"
                        type="number"
                        v-model="item.standardValue"
                        outlined hide-details="auto" disabled>
                      </v-text-field>
                    </li>
                    <li class="value">
                      <v-text-field
                        :label="'カスタマイズ価格 ( ' + getPercent(item) + '% )'"
                        type="number"
                        v-model="item.value"
                        :rules="[rules.required, rules.integer, rules.min0]"
                        class="required"
                        outlined hide-details="auto">
                      </v-text-field>
                    </li>
                  </ul>
                  <div class="model-ctrl">
                    <toggle-button
                      v-model="item.enabled"
                      :labels="{checked: '有効', unchecked: '無効'}"
                      color="#0277bd"
                      :width="70" :height="30" :font-size="14" />
                  </div>
                </li>
              </ul>
            </div>
            <div class="pt-8">
              <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid" depressed block>
                <v-icon left>fas fa-save</v-icon>登録
              </v-btn>
            </div>
          </v-form>
        </section>
      </div>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation, Storage } from 'aws-amplify'
import { createSubModel, updateSubModel } from '../graphql/mutations'
import { listCustomers, listProducts, listModels, listSubModels } from '../graphql/queries'

export default {
  data() {
    return {
      search: '',
      loading: true,
      valid: false,
      saving: false,
      customers: [],
      products: [],
      models: [],
      desserts: [],
      productItem: {},
      selectProduct: null,
      selectCustomer: null,
    }
  },
  prop: {},
  mounted: async function() {
    //customers
    await this.getCustomers()
    //products
    await this.getProducts()
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    productItems() {
      const map = []
      this.products.forEach(e => {
        map.push({
          value: e.id,
          text: (e.category ? e.category + ' - ' : '') + e.name,
        })
      })
      return map
    },
    customerItems() {
      const map = []
      this.customers.forEach(e => {
        map.push({
          value: e.id,
          text: e.name + (e.office ? '（' + e.office + '）' : ''),
          rate: e.rate,
        })
      })
      return map
    },
  },
  watch: {
    selectProduct() {
      this.queryModels()
    },
    selectCustomer() {
      this.queryModels()
    },
  },
  methods: {
    //品目の取得
    async queryModels() {
      if (!!this.selectProduct && !!this.selectCustomer) {
        this.desserts = []
        //商品
        const product = this.products.find(e => e.id === this.selectProduct.value)
        this.productItem = Object.assign({}, product)
        //メイン画像
        await Storage.get(this.productItem.mainPic).then(data => {
          this.productItem.mainPicUrl = data
        })
        //品目 ※オリジナル
        this.models = []
        await this.getModels(this.models, product.id)
        this.models.sort(function(a,b) {
          if (a.createdAt < b.createdAt) return -1
          if (a.createdAt > b.createdAt) return 1
          return 0
        })

        for (const row of this.models) {
          //modelID
          row.modelID = row.id
          //メイン画像
          await Storage.get(row.mainPic).then(data => {
            row.mainPic = data
          })
          //有効・無効
          row.enabled = true
          //定価
          row.staticValue = row.value
          //標準価格
          row.standardValue = Math.floor(row.value * (this.selectCustomer.rate / 100))
          //定価
          row.value = row.standardValue
          //客先向け商品
          const subModels = await API.graphql(graphqlOperation(listSubModels, {
            filter: {
              modelID: { eq: row.id },
              customerID: { eq: this.selectCustomer.value },
            },
            limit: 100,
          }))
          //客先向け商品の登録があれば上書き
          if (subModels.data.listSubModels.items.length > 0) {
            const submodel = subModels.data.listSubModels.items[0]
            row.id = submodel.id
            row.name = submodel.name
            row.code = submodel.code || null
            row.value = submodel.value
            row.enabled = submodel.enabled
          } else {
            delete row.id
          }
          this.desserts.push(row)
        }

        this.loading = false
      }
    },
    //保存
    async save() {
      try {
        if (confirm(this.selectProduct.text + ' の ' + this.selectCustomer.text + '向け情報を更新しますか？')) {
          this.saving = true
          for (const model of this.desserts) {
            let child = this.getSubModel(model)
            if (child.id) {
              await API.graphql(graphqlOperation(updateSubModel, {input: child}))
            } else {
              delete child.id
              await API.graphql(graphqlOperation(createSubModel, {input: child}))
            }
          }
          this.log({ type: this.$route.name, text: '[' + this.selectProduct.text + '] の [' + this.selectCustomer.text + '] 向け情報を更新しました' })
          this.myAlert('客先向け商品を更新しました', 'success')
          this.saving = false
        }
      } catch (e) {
        this.myAlert(e)
        this.saving = false
      }
    },
    //品目データ
    getSubModel(subModel) {
      return {
        id: subModel.id || null,
        modelID: subModel.modelID || this.selectProduct.value,
        customerID: subModel.customerID || this.selectCustomer.value,
        name: subModel.name || null,
        code: subModel.code || null,
        value: subModel.value || null,
        enabled: subModel.enabled,
      }
    },
    //アコーディオンの開閉
    switchAccordion(e) {
      const target = e.target.parentElement.nextSibling
      target.style.display = target.style.display == 'none' ? 'block' : 'none'
      e.target.classList.toggle('opened')
    },
    //percentageの取得
    getPercent(item) {
      const staticValue = item.staticValue || 0
      const customizeValue = item.value || 0
      return Math.floor(customizeValue / staticValue * 100)
    },
    //客先の取得
    async getCustomers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listCustomers, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listCustomers.items) {
        this.customers.push(data)
      }
      if (query.data.listCustomers.nextToken) this.getCustomers(query.data.listCustomers.nextToken)
    },
    //商品の取得
    async getProducts(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listProducts, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listProducts.items) {
        this.products.push(data)
      }
      if (query.data.listProducts.nextToken) this.getProducts(query.data.listProducts.nextToken)
    },
    //品目の取得
    async getModels(target, productID, nextToken = null) {
      const query = await API.graphql(graphqlOperation(listModels, {
        filter: {
          productID: { eq: productID }
        },
        limit: 100,
        nextToken: nextToken
      }))
      for (const data of query.data.listModels.items) {
        target.push(data)
      }
      if (query.data.listModels.nextToken) this.getModels(productID, query.data.listModels.nextToken)
    },
  },
  components: {

  },
}
</script>

<style lang='scss' scoped>
.product-outline {
  position: relative;
  .img {
    position: absolute;
    left: 0;
  }
  .outline {
    margin-left: 140px;
  }
}
.quill-editor {
  .ql-editor {
    border: 1px solid #BBB;
    border-radius: 5px;
    padding: 15px;
  }
}
.model-list {
  list-style: none;
  padding: 0;
  & > li {
    position: relative;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #DDD;
    &:last-of-type {
      padding-bottom: 0;
      margin-bottom: 0;
      border-bottom: none;
    }
    .model-image {
      position: absolute;
      top: 5px;
      left: 0;
    }
    .model-row {
      list-style: none;
      padding: 0;
      letter-spacing: -.4em;
      margin-left: 140px;
      margin-right: 110px;
      li {
        letter-spacing: normal;
        display: inline-block;
        padding: 5px;
        &.name { width: calc(100% / 2); padding-left: 0; }
        &.code { width: calc(100% / 2); }
        &.size { width: calc(100% / 3); padding-left: 0; }
        &.color { width: calc(100% / 3); }
        &.material { width: calc(100% / 3); }
        &.static-value { width: calc(100% / 3); padding-left: 0; }
        &.standard-value { width: calc(100% / 3); }
        &.value { width: calc(100% / 3); }
      }
    }
    .model-ctrl {
      position: absolute;
      right: 0;
      top: 15px;
      width: 100px;
      text-align: center;
    }
  }
}
</style>
